import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiUser } from "react-icons/fi";

const CastingDirectorInfoSection = ({
  formData,
  castingDirectors,
  loadingDirectors,
  handleCastingDirectorChange
}) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div className="bma-icon-circle"><FiUser /></div>
          <h2 className="bma-card-title">1. Casting Director Information</h2>
        </div>
        <Row className="g-3">
          <Col md={6}>
            <label className="bma-label">
              Casting Director <span className="req">*</span>
            </label>
            <select
              name="casting_director_id"
              className="bma-select"
              value={formData.casting_director_id ? String(formData.casting_director_id) : ""}
              onChange={handleCastingDirectorChange}
              disabled={loadingDirectors}
              required
            >
              <option value="">{loadingDirectors ? "Loading Casting Directors..." : "Select Casting Director"}</option>
              {castingDirectors.map((d) => (
                <option key={d.id} value={String(d.id)}>
                  {d.name}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CastingDirectorInfoSection;